import merge from 'lodash.merge';
import platformSharedDeJson from './platform-shared/de.json';
import platformSharedEnJson from './platform-shared/en.json';
import agGridEnJson from './ag-grid/en.json';
import agGridDeJson from './ag-grid/de.json';

const platformSharedLocales = {
  en: merge(agGridEnJson, platformSharedEnJson),
  de: merge(agGridDeJson, platformSharedDeJson),
};

export { platformSharedLocales };
